import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/index';
import { User } from '../../models/user.model';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-user-list',
  styleUrls: ['../defis/defi-list.component.scss'],
  templateUrl: './user-list.component.html',
})
export class UserListComponent implements OnInit {
  // font awesome
  public faEdit = faEdit;

  // loading indicator
  loading = false;

  @ViewChild('editItemTmpl', { static: true }) editItemTmpl: TemplateRef<any>;
  @ViewChild('countryTmpl', { static: true }) countryTmpl: TemplateRef<any>;
  @ViewChild('partnerTmpl', { static: true }) partnerTmpl: TemplateRef<any>;
  @ViewChild('rolesTmpl', { static: true }) rolesTmpl: TemplateRef<any>;

  // column definition
  columns;

  data: Array<User>;

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.columns = [
      { prop: 'name', name: 'Name', width: 200 },
      { prop: 'email', name: 'Email', width: 200 },
      { cellTemplate: this.rolesTmpl, name: 'Roles', width: 120 },
      { cellTemplate: this.countryTmpl, name: 'Countries', width: 150 },
      { cellTemplate: this.partnerTmpl, name: 'Partner', width: 150 },
      { name: 'Actions', cellTemplate: this.editItemTmpl, width: 20 },
    ];

    // indicate loading
    this.loading = true;

    // load data
    this.loadData();
    console.log('111', this.data);
  }

  private loadData() {
    // load data (take, skip)
    this.api.getAdmins().subscribe((response) => {
      // store the data
      this.data = new Array<User>();

      for (const entry of response) {
        this.data.push(new User().deserialize(entry));
      }

      // loading finished
      this.loading = false;
    });
  }
}
